import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Typography, Spin, DatePicker } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useFootfall from '../useFootfall';
import LineChart from '../../../charts/lineChart';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import moment from 'moment';
import Helpers from '../../../../../helpers';
import FootfallPrint from '../../footfall/print';
import SalesPrint from '../../invoicesSalesVillage/print';
import InvoicesCompareFootfallSalesPrint from '../../invoicesCompareFootfallSales/print';
import InvoicesConversionRateVillagePrint from '../../invoicesConversionRateVillage/print';
import InvoicesAtvVillagePrint from '../../invoicesAtvVillage/print';
import InvoicesUptVillagePrint from '../../invoicesUptVillage/print';
import InvoicesPiecesPrint from '../../invoicesPieces/print';
import InvoicesTicketsPrint from '../../invoicesTickets/print';
import KpiPrint from '../../kpi/print';
import KpiWeekdaysHolidaysPrint from '../../kpiWeekdaysHolidays/print';
import ConsumiNetSalesPrint from '../../consumiNetSales/print';
import InvoicesCategoryPiecesPrint from '../../invoicesCategoryPieces/print';
import InvoicesCategoryTicketsPrint from '../../invoicesCategoryTickets/print';
import StoreVsVillagePrint from '../../storeVsVillage/print';
import FootfallStoreVsVillagePrint from '../../footfallStoreVsVillage/print';
import InvoicesSalesCompetitorsPrint from '../../invoicesSalesCompetitors/print';
import InvoicesSalesTrendsPrint from '../../invoicesSalesTrends/print';
import SalesTrackingsGenderAgePrint from '../../salesTrackingsGenderAge/print';
import SalesTrackingsGenderBrandPrint from '../../salesTrackingsGenderBrand/print';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    title,
    searchParams,
    format,
    loading,
    summary,
    handleDownloadExcel,
    handleDownloadPdf,
    loadingPdf,
    errors,
  } = useFootfall();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('All Reports').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              big
              icon={<PlusOutlined />}
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        {/*<Filters filters={filters} />*/}
        <bt />
        <Spin spinning={loading}>
          <Row>
            <Col span={24}>
              <FootfallPrint
                isAllReports
                isMain
                allReportsData={data.footfalls}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <SalesPrint
                isAllReports
                isMain
                allReportsData={data.sales}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesCompareFootfallSalesPrint
                isAllReports
                isMain
                allReportsData={data.footfall_sales}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesConversionRateVillagePrint
                isAllReports
                isMain
                allReportsData={data.conversion_rate}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesAtvVillagePrint
                isAllReports
                isMain
                allReportsData={data.atv}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesUptVillagePrint
                isAllReports
                isMain
                allReportsData={data.upt}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesPiecesPrint
                isAllReports
                isMain
                allReportsData={data.pieces}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesTicketsPrint
                isAllReports
                isMain
                allReportsData={data.tickets}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <KpiPrint
                isAllReports
                isMain
                allReportsData={data.kpi}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <KpiWeekdaysHolidaysPrint
                isAllReports
                isMain
                allReportsData={data.kpi_weekdays_holidays}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <ConsumiNetSalesPrint
                isAllReports
                isMain
                allReportsData={data.consumi_net_sales}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesCategoryPiecesPrint
                isAllReports
                isMain
                allReportsData={data.consumi_pieces}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesCategoryTicketsPrint
                isAllReports
                isMain
                allReportsData={data.consumi_tikets}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <StoreVsVillagePrint
                isAllReports
                isMain
                allReportsData={data.store_vs_village}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <FootfallStoreVsVillagePrint
                isAllReports
                isMain
                allReportsData={data.footfall_store_vs_village}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesSalesCompetitorsPrint
                isAllReports
                isMain
                allReportsData={data.sales_competitors}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <InvoicesSalesTrendsPrint
                isAllReports
                isMain
                allReportsData={data.brand_cross_village}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <SalesTrackingsGenderAgePrint
                isAllReports
                isMain
                allReportsData={data.gender_age}
                allReports={true}
              />
            </Col>
            <Col span={24}>
              <SalesTrackingsGenderBrandPrint
                isAllReports
                isMain
                allReportsData={data.gender_brand}
                allReports={true}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default MainPage;
